const config = {
    baseEndpoint: 'https://ir.design-portfolio.co.uk',
    companyID: 121,
    dateFormat: 'dd MMMM y',
    articlesPerPage: 10
};

export default config;
